var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
};

site.frontpage = {
	init:function() {
		$(document).ready(function() {
			const banner = document.getElementById('stredva');
			if (banner) {
				banner.style.setProperty('display', 'block', 'important');
			}
			site.owl.init('#hero ul', {
				nav: false,
				loop: true,
				items: 1,
				dots: true,
				stopOnHover: true,
				autoplay: true,
				mouseDrag: true,
				autoplayTimeout:8000,
				smartSpeed: 500,
				autoplayHoverPause: true,
			});
		});

		site.owl.init('#owl-frontbox', {
			loop: true,
			dots: true,
			nav: false,
			items: 1,
			stopOnHover: true,
			autoplay: true,
			autoplayTimeout: 8000,
			autoplayHoverPause: true
		});

		site.frontpage.tabs();
		site.frontpage.responsiveDom();

		site.owl.init('.box_social_instagram #instagram .grams', {
			loop: true,
			dots: false,
			nav: true,
			navText: ["<div class=\"arrow\"><i class=\"fa fa-chevron-left\"></i></div>", "<div class=\"arrow\"><i class=\"fa fa-chevron-right\"></i></div>"],
			stopOnHover: true,
			navSpeed:2000,
			margin: 5,
			responsive: {
				0: {
					items: 1
				},
				520: {
					items: 2
				},
				786: {
					items: 3
				},
				992: {
					items: 4
				},
				1200: {
					items: 5
				},
				1500: {
					items: 6
				}
			},
			autoplay: true,
			autoplayTimeout: 6000,
			autoplaySpeed: 2000,
			autoplayHoverPause: true
		});

		site.owl.init('#banner .hasCarousel .items', {
			nav: true,
			margin: 15,
			navText: "",
			responsive: {
				0: {
					items: 1
				},
			},
		});
	},

	overWrite:function(count, codename) {
		const $form = $('#moya_form_allir-med-undirskrift');

		if ($form && codename === 'allir-med-undirskrift') {
			const $text = $form.find('#elm_text1 .lmnt');
			const $parent = $form.find('#elm_text1');
			if ($text && $parent) {

				$text.addClass('hidden');
				$element = '';

				if (count === 0) {
					$element = '<span>' + 'Það er enginn búinn að skrá sig.' + '</span>';
				} else if (count === 1) {
					$element = '<span>' + 'Það er ' + count +  ' búinn að skrá sig.' + '</span>';
				} else {
					$element = '<span>' + 'Það eru ' + count + ' búnir að skrá sig.' + '</span>';
				}

				$($element).appendTo($parent);
			}
		}
	},

	tabs:function() {
		var $tabs = $('#frontTabs');
		$tabs.tabs();
		$tabs.removeClass('ui-widget ui-widget-content ui-corner-all');
		$('>ul', $tabs).removeClass('ui-widget-header ui-corner-all');
		$('>ul > li', $tabs).removeClass('ui-state-default ui-corner-top');
		$('>div',$tabs).removeClass('ui-widget-content ui-corner-bottom');
	},

	responsiveDom: function() {
		var $target = $('.box_calendar_eventlist');
		$target.responsiveDom({
			prependTo: '#box_group_1 > .contentWrap',
			mediaQuery: 'screen and (max-width: 991px)',
		});
	}
};

site.formbuilder = {
	init:function() {
		$('.moya_form', '#formbuilder').each(function() {
			var $this = $(this);
			if ($this.find('fieldset').length > 0) {
				$this.addClass('hasFieldset');
			}
		});
	}
};

site.faq = {
	init : function() {
		var $faq = $('#faq');
		if ($faq.length === 0) return false;

		$('.answer', $faq).each(function() {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});

		$(window).resize(function() {
			$('.answer', $faq).each(function() {
				$(this).css('max-height', $(this)[0].scrollHeight);
			});
		});

		$faq.find('.question').click(function() {
			$(this).parent('li').toggleClass('open');
		});
		$faq.find('#cancel').click(function() {
			window.history.back();
		});
	}
};

site.alerts = {
	init: function () {
		var $body = $('body');

		if ($('.box.box_aitems #alert').length) {
			$body.addClass('hasAlert');
		}
		window.addEventListener("scroll", () => {
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			if (scrollTop > 85) {
				$body.addClass('scroll');
			} else {
				$body.removeClass('scroll');
			}
		});
	}
};

// Siteimprove stuff
site.formAcessiblity = {
	init : function () {
		var $form = $('form');
		if($form.length === 0) return false;
		var $submit = $form.find('input[type="submit"]');
		var $value = $submit.prop('value')
		$submit.prop('title', $value);
	}
};

// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.frontpage.init();
	site.megamenu.init();
	site.formbuilder.init();
	site.faq.init();
	site.alerts.init();
	site.formAcessiblity.init();

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	$( window ).on( "load", function() {
		$('iframe', '#abendingar').each(function() {
			$(this).attr('title', 'Var efnið á síðunni hjálplegt');
		});
	});

	// Responsive tables
	if (!$('body').is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Touch login
	$('.login').dblclick(function(e) {
		e.preventDefault();
		window.location = '/moya';
	});

	$('.wrap a.more').hover(function() {
		$(this).siblings('.date').addClass('add_orange');
	}, function() {
		$(this).siblings('.date').removeClass('add_orange');
	});

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
